const TAXAS = {
  PIX: { fixa: 1.99, percentual: 0 },
  CREDIT_CARD: { fixa: 0.49, percentual: 0.0499 }
}
// Padrao da plataforma. Espelha COMISSAO_PLATAFORMA_LIQUIDA na API (lib/taxas.js).
const COMISSAO_PLATAFORMA = 5.00
const MAX_CONVIDADOS = 4

function round2(v) { return Math.round((v || 0) * 100) / 100 }

/**
 * Meia inscricao por faixa. Espelha FATOR em lib/faixaEtaria.js na API — se
 * divergir, a tela mostra um total diferente do que o gateway vai cobrar.
 */
const FATOR = { INTEIRA: 1, MEIA: 0.5, ISENTA: 0 }
const FAIXA_PADRAO = 'INTEIRA'

export function fatorDaFaixa(tipo) {
  return Object.prototype.hasOwnProperty.call(FATOR, tipo) ? FATOR[tipo] : FATOR[FAIXA_PADRAO]
}

export function valorDaFaixa(valorBase, tipo) {
  return round2((Number(valorBase) || 0) * fatorDaFaixa(tipo))
}

/** Arredonda POR PARTICIPANTE e depois soma, para o total bater com as linhas. */
export function totalDasFaixas(valorBase, tipos) {
  return round2((tipos || []).reduce((soma, t) => soma + valorDaFaixa(valorBase, t), 0))
}

/**
 * Aceita lista de faixas OU numero — o numero e o caminho de compatibilidade
 * de quem ainda pensa em "tamanho" e vira N inteiras.
 */
function faixasDe(tamanhoOuFaixas) {
  if (Array.isArray(tamanhoOuFaixas)) {
    return tamanhoOuFaixas.map(t => (
      Object.prototype.hasOwnProperty.call(FATOR, t) ? t : FAIXA_PADRAO
    ))
  }
  const n = Math.max(1, Number(tamanhoOuFaixas) || 1)
  return Array.from({ length: n }, () => FAIXA_PADRAO)
}

/**
 * Resolve a comissao a partir da config publica do evento ({ tipo, valor }),
 * que vem em `evento.comissao`. Sem config, usa o padrao — assim eventos
 * antigos continuam cobrando o mesmo de sempre.
 */
export function resolverComissao(comissaoConfig, base = 0) {
  const v = Number(comissaoConfig?.valor)
  if (!Number.isFinite(v) || v < 0) return COMISSAO_PLATAFORMA
  if (comissaoConfig?.tipo === 'PERCENTUAL') return round2((Number(base) || 0) * v / 100)
  return round2(v)
}

/**
 * Modo PRECO FINAL: `valorPlanoBase` ja e o que o inscrito paga, por pessoa.
 * Comissao e taxa saem de DENTRO (quem absorve e o evento), entao o total e
 * `preco x N` exato. Espelha calcularCobrancaPrecoFinal na API (lib/taxas.js).
 */
export function calcularBreakdownPrecoFinal(precoFinal, forma, tamanho = 1, comissaoConfig = null) {
  const t = TAXAS[forma] || TAXAS.PIX
  const faixas = faixasDe(tamanho).slice(0, 5)
  const n = Math.max(1, faixas.length)
  const total = totalDasFaixas(precoFinal, faixas)
  const comissaoPlataforma = comissaoConfig
    ? resolverComissao(comissaoConfig, total)
    : COMISSAO_PLATAFORMA
  const taxaGateway = round2(total * t.percentual + t.fixa)
  const valorPlanoTotal = round2(total - comissaoPlataforma - taxaGateway)
  return {
    forma,
    tamanho: n,
    valorPlanoBase: round2(valorPlanoTotal / n),
    valorPlanoTotal,
    comissaoPlataforma,
    taxaGateway,
    total
  }
}

/** Escolhe o modo pelo plano. Espelha calcularCobrancaDoPlano na API. */
export function calcularBreakdownDoPlano(plano, valorBase, forma, tamanho = 1, comissaoConfig = null) {
  return plano?.precoFinal
    ? calcularBreakdownPrecoFinal(valorBase, forma, tamanho, comissaoConfig)
    : calcularBreakdownGrupo(valorBase, forma, tamanho, comissaoConfig)
}

export function calcularBreakdownGrupo(valorPlanoBase, forma, tamanho = 1, comissaoConfig = null) {
  const t = TAXAS[forma] || TAXAS.PIX
  const faixas = faixasDe(tamanho).slice(0, 5)
  const n = Math.max(1, faixas.length)
  const valorPlanoTotal = totalDasFaixas(valorPlanoBase, faixas)
  const comissaoPlataforma = comissaoConfig
    ? resolverComissao(comissaoConfig, valorPlanoTotal)
    : COMISSAO_PLATAFORMA
  const liquidoAlvo = valorPlanoTotal + comissaoPlataforma
  const total = round2((liquidoAlvo + t.fixa) / (1 - t.percentual))
  const taxaGateway = round2(total - liquidoAlvo)
  return {
    forma,
    tamanho: n,
    valorPlanoBase: round2(valorPlanoBase),
    valorPlanoTotal,
    comissaoPlataforma,
    taxaGateway,
    total
  }
}

export { MAX_CONVIDADOS, COMISSAO_PLATAFORMA, FATOR, FAIXA_PADRAO }
